import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { Dispatch } from "react";

export interface TextureFilterProps {
  value?: Array<AutocompleteData>;
  onChange?: Dispatch<Array<AutocompleteData>>;
  t: (key: string) => string;
}

export const TextureFilter = ({
  value = [],
  onChange,
  t,
}: TextureFilterProps) => {
  return (
    <ColorSearchAutocomplete
      label={t("filter_omd_texture")}
      example={"Semi-matt"}
      type="texture"
      value={value}
      onChange={onChange}
    />
  );
};
